<template>
<div class="order-detail">
    <div class="bg-head-nav"></div>
    <div class="content-detail">
        <div class="baseinfo">
            <div class="baseinfo-title">审核订单信息</div>
            <div class="baseinfo-content">
                <div class="baseinfo-content-left el-row">
                    <div class="el-col el-col-12">
                        <p><span >卖方：</span> <span >{{orderInfo.seller_name}}</span></p>
                        <p><span >发货地：</span> <span >{{orderInfo.seller_address}}</span></p>
                        <p><span >订货人：</span> <span >{{orderInfo.create_user}}</span></p>
                        <p><span >订单号：</span> <span >{{orderInfo.order_id}}</span></p>
                    </div>
                    <div class="baseinfo-content-right el-col el-col-12">
                        <p><span >买方：</span> <span >{{orderInfo.buyer_name}}</span></p>
                        <p><span >收货地：</span> <span >{{orderInfo.address}}</span></p>
                        <p><span >联系电话：</span> <span >{{orderInfo.contact_number}}</span></p>
                        <p><span >日期：</span> <span >{{orderInfo.date}}</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="orderinfo">
            <el-table :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" class="order-detail-table" :data="orderInfo.orderitem" stripe style="width: 100%">
                <el-table-column align="center" label="最后敲定价格" min-width="20%">
                    <template slot-scope="scope">
                        <span v-if="orderInfo.order_type_num == 1 && checkUserInfo[0].user_id == user.id && !checkUserInfo[0].check_status"><el-input-number v-model="scope.row.orderitem_last_price" @change="changeLastPrice" :min="0"></el-input-number></span>
                        <span v-else>{{scope.row.orderitem_last_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderitem_good_name" label="商品名称" align="center" min-width="27%">
                </el-table-column>
                <!-- 20 27 17 18 18 -->
                <el-table-column prop="orderitem_material_code" label="物料编码" align="center" min-width="17%">
                </el-table-column>
                <el-table-column prop="numbers" label="数量" align="center" min-width="18%">
                </el-table-column>
                <el-table-column prop="orderitem_price" align="center" label="价格" min-width="18%">
                </el-table-column>
            </el-table>
            <div class="total-price">
                <span style="margin-right: 10px;">共{{goodNum}}件商品</span>
                <span class="total-price-text">合计：</span>
                <span class="total-price-money" style="color: rgb(255, 110, 21);">￥{{totalPrice}}</span>
            </div>
        </div>
        <div v-if="orderInfo.order_type_num == 1" class="check-process">
            <div class="seller">
                <p><span>销售代表</span><span>{{checkUserInfo[0].name}}</span></p>
                <p><span>电话</span><span>{{checkUserInfo[0].phone}}</span></p>
                <div class="area-check">
                    <p v-if="!checkUserInfo[0].check_status"><span @click="submitCheck(0)" class="circle">提交审核</span><span style="padding-left: 16px; font-size: 16px; color: rgb(123, 123, 123);">(待填写价格)</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
            </div>
            <div class="area-manager">
                <p><span >区域经理</span><span >{{checkUserInfo[1].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[1].phone}}</span></p>
                <div v-if="orderInfo.status > 0" class="area-check">
                    <p v-if="!checkUserInfo[1].check_status"><span @click="submitCheck(1)" class="circle">提交审核</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <div v-if="orderInfo.status > 0" class="area-check">
                    <p v-if="!checkUserInfo[1].check_status"><span @click="rejectCheck(1)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div>
            </div>
            <div class="logistics">
                <p><span>物流岗位</span><span >{{checkUserInfo[2].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[2].phone}}</span></p>
                <div v-if="orderInfo.status > 1" class="area-check">
                    <p v-if="!checkUserInfo[2].check_status"><span @click="submitCheck(2)" class="circle">提交审核</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <div v-if="orderInfo.status > 1" class="area-check">
                    <p v-if="!checkUserInfo[2].check_status"><span @click="rejectCheck(2)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div>
                <!-- <div v-if="orderInfo.status > 1" class="area-check">
                    <p v-if="!checkUserInfo[2].check_status" @click="writeAddress(2)" class="changeAddress">填写发货地</p>
                    <p v-else class="changeAddress bg-green">填写发货地</p>
                </div> -->
            </div>
            <div class="price-manager">
                <p><span >价格岗位</span><span >{{checkUserInfo[3].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[3].phone}}</span></p>
                <div v-if="orderInfo.status > 2" class="area-check">
                    <p v-if="!checkUserInfo[3].check_status"><span @click="submitCheck(3)" class="circle">提交审核</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <div v-if="orderInfo.status > 2" class="area-check">
                    <p v-if="!checkUserInfo[3].check_status"><span @click="rejectCheck(3)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div>
            </div>
            <div class="order-detail-check-bg">
                <s v-if="!checkUserInfo[0].check_status && orderInfo.status == 0" class="order-detail-small-circle small-circle1 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle1 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[1].check_status && orderInfo.status == 1" class="order-detail-small-circle small-circle2 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle2 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[2].check_status && orderInfo.status == 2" class="order-detail-small-circle small-circle3 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle3 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[3].check_status && orderInfo.status == 3" class="order-detail-small-circle small-circle4 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle4 order-detail-circle-empty"></s>
            </div>
        </div>
        <!-- 非油订单审核 -->
        <div v-if="isFeiyouOrder" class="check-process">
            <div class="seller">
                <p><span>{{checkUserInfo[0].position}}</span><span>{{checkUserInfo[0].name}}</span></p>
                <p><span>电话</span><span>{{checkUserInfo[0].phone}}</span></p>
                <div class="area-check">
                    <p v-if="!checkUserInfo[0].check_status"><span @click="submitCheck(4)" class="circle">提交审核</span><span style="padding-left: 16px; font-size: 16px; color: rgb(123, 123, 123);">(待填写价格)</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <div  class="area-check">
                    <p v-if="!checkUserInfo[0].check_status"><span @click="rejectCheck(4)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div>
            </div>
            <div class="logistics">
                <p><span>{{checkUserInfo[1].position}}</span><span >{{checkUserInfo[1].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[1].phone}}</span></p>
                <div v-if="orderInfo.status > 0" class="area-check">
                    <p v-if="!checkUserInfo[1].check_status"><span @click="submitCheck(5)" class="circle">提交审核</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <!-- <div v-if="orderInfo.status > 0" class="area-check">
                    <p v-if="!checkUserInfo[1].check_status"><span @click="rejectCheck(2)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div> -->
                <div v-if="orderInfo.status > 0" class="area-check">
                    <!-- <p v-if="!checkUserInfo[2].check_status" @click="writeAddress(2)" class="changeAddress">填写发货地</p>
                    <p v-else class="changeAddress b g-green">填写发货地</p> -->
                    <!-- 直发库和前置仓库选择器 -->
                    <el-select v-if="!checkUserInfo[1].check_status && user.id == checkUserInfo[1].user_id" @change="selectDeliveryPerson(deliveryIndex)" v-model="deliveryIndex" placeholder="请选择配送商...">
                        <el-option
                        v-for="(item, index) in deliveryArr"
                        :key="index"
                        :label="item.label"
                        :value="index">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="price-manager">
                <p><span >{{checkUserInfo[2].position}}</span><span >{{checkUserInfo[2].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[2].phone}}</span></p>
                <div v-if="orderInfo.status > 1" class="area-check">
                    <p v-if="!checkUserInfo[2].check_status && user.id == checkUserInfo[2].user_id"><span @click="submitCheck(6)" class="circle">提交审核</span></p>
                    <p v-else><span class="circle bg-green">提交审核</span></p>
                </div>
                <div v-if="orderInfo.status > 1" class="area-check">
                    <el-select v-if="!checkUserInfo[2].check_status && user.id == checkUserInfo[2].user_id" @change="selectWarehouse(warehouseIndex)" v-model="warehouseIndex" placeholder="请选择仓库...">
                        <el-option
                        v-for="(item, index) in warehouseArr"
                        :key="index"
                        :label="item.warehouse_name"
                        :value="index">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="orderInfo.status > 1" class="area-check">
                    <el-select v-if="!checkUserInfo[2].check_status && user.id == checkUserInfo[2].user_id" @change="selectDeliveryExpressPerson(deliveryExpressIndex)" v-model="deliveryExpressIndex" placeholder="请选择配送员...">
                        <el-option
                        v-for="(item, index) in deliveryExpressArr"
                        :key="index"
                        :label="item.name"
                        :value="index">
                        </el-option>
                    </el-select>
                </div>
                <!-- <div v-if="orderInfo.status > 1" class="area-check">
                    <p v-if="!checkUserInfo[2].check_status"><span @click="rejectCheck(3)" class="btn-reject">驳回审核</span></p>
                    <p v-else><span class="btn-reject bg-green">驳回审核</span></p>
                </div> -->
            </div>
            <!-- <div class="order-detail-check-bg">
                <s v-if="!checkUserInfo[0].check_status && orderInfo.status == 0" class="order-detail-small-circle small-circle1 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle1 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[1].check_status && orderInfo.status == 1" class="order-detail-small-circle small-circle2 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle2 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[2].check_status && orderInfo.status == 2" class="order-detail-small-circle small-circle3 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle3 order-detail-circle-empty"></s>
                <s v-if="!checkUserInfo[3].check_status && orderInfo.status == 3" class="order-detail-small-circle small-circle4 order-detail-circle-full"></s>
                <s v-else class="order-detail-small-circle small-circle4 order-detail-circle-empty"></s>
            </div> -->
        </div>
        <div v-if="orderInfo.order_type_num == 0" class="check-process">
            <div class="area-manager">
                <p><span >总经理</span><span >{{checkUserInfo[0].name}}</span></p>
                <p><span >电话</span><span >{{checkUserInfo[0].phone}}</span></p>
                <div class="area-check">
                    <p v-if="!checkUserInfo[0].check_status"><span @click="checkStore" id="areaManagerCircle" class="circle">提交审核</span></p>
                    <p v-else><span id="areaManagerCircle" class="circle bg-green">提交审核</span></p>
                </div>
                <div class="area-check">
                    <p v-if="!checkUserInfo[0].check_status" @click="writeAddress(2)" class="changeAddress">填写发货地</p>
                    <p v-else class="changeAddress bg-green">填写发货地</p>
                </div>
            </div>
        </div>
    </div>
    <div v-if="orderInfo.order_type_num == 1">
        <!-- <div v-if="orderInfo.status > 3" class="btn-checkSend">配送管理</div> -->
        <div v-if="orderInfo.status > 3" class="btn-downContract" @click="downloadContract">下载合同</div>
    </div>
    <div v-if="orderInfo.order_type_num == 0">
        <!-- <div v-if="orderInfo.status > 0" class="btn-checkSend">配送管理</div> -->
        <div v-if="orderInfo.status > 1" class="btn-downContract" @click="downloadContract">下载合同</div>
    </div>
    <div v-if="isFeiyouOrder && (orderInfo.status > 2)">
        <div class="btn-downContract" @click="downloadDeliveryPaper">下载配送单</div>
    </div>
    <div class="dialog-group">
        <el-dialog title="发货地址" :visible.sync="dialogFormVisible">
            <el-form>
                <el-form-item label="发货地址:" :label-width="formLabelWidth">
                    <el-input v-model="outGoodsAddress" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="outGoodsQuit">取 消</el-button>
                <el-button type="primary" @click="outGoodsOk">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    mapGetters, mapMutations
} from 'vuex';
import Cookie from 'js-cookie';
export default {
    data() {
        return {
            isFeiyouOrder: false,
            outGoodsAddress: '',
            orderInfo: {},
            checkUserInfo: [],
            dialogFormVisible: false,
            formLabelWidth: '120px',
            user: {}
        }
    },
    computed: {
        // ...mapGetters(['user']),
        totalPrice() {
            var price = 0;
            this.orderInfo.orderitem.forEach(item => {
                price += parseFloat(item.orderitem_last_price);
            });
            return price;
        },
        goodNum() {
            var goodNum = 0;
            return this.orderInfo.orderitem.length;
        }
    },
    async created() {
        let state = JSON.parse(localStorage.getItem('state'));
        console.log('state: ', state);
        this.initState(state);


        this.user = state.user
        // console.log('user', user);
        // this.user = JSON.parse(user);
        if(this.$route.query.isStation == 'yes') {
            this.isFeiyouOrder = true;
            let deliveryInfo = await this.axios.get('distributor_list')
            this.deliveryArr = deliveryInfo.data.data;
            // distributor_express_list
            console.log('this.user: ', this.user);
            let deliveryExpressList = await this.axios.get('distributor_express_list?user_id=' + this.user.id);
            this.deliveryExpressArr = deliveryExpressList.data.data;
        }
        this.init()
    },
    methods: {
        ...mapMutations(['initState']),
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 4) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            let url ;
            if(this.$route.query.isStation) {
                url = 'station_order_detail';
            }
            else {
                url = 'order_detail';
            }
            this.axios.get(url, {
                    params: {
                        oid: this.$route.query.oid
                    }
                })
                .then(res => {
                    res.data.data.orderitem.forEach(item => {
                        if(res.status == 0) {
                            item.orderitem_last_price = parseFloat(item.orderitem_total_price);
                        }
                    })
                    this.orderInfo = res.data.data;
                    this.checkUserInfo = res.data.data.check_user;
                })
        },
        downloadDeliveryPaper() {
            window.location.href = 'https://xarh.sprucesmart.com/api/v1/download_transport_excel?oid=' + this.$route.query.oid;
        },
        // 修改最后敲定价格
        changeLastPrice(price) {
            // alert('price: ' + price);
        },
        // 提交审核
        submitCheck(flag) {
            console.log('submitCheck');
            if (flag == 0) {
                this.user.id == this.checkUserInfo[0].user_id ? this.sellerCheck() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            } else if (flag == 1) {
                this.user.id == this.checkUserInfo[1].user_id ? this.areaCheck() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            } else if (flag == 2) {
                this.user.id == this.checkUserInfo[2].user_id ? this.logisticsCheck() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            } else {
                this.user.id == this.checkUserInfo[3].user_id ? this.priceCheck() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            }
        },
        // 驳回审核
        rejectCheck(flag) {
            console.log('rejectCheck');
            if (flag == 1) {
                this.user.id == this.checkUserInfo[1].user_id ? this.areaReject() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            } else if (flag == 2) {
                this.user.id == this.checkUserInfo[2].user_id ? this.logisticsReject() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            } else {
                this.user.id == this.checkUserInfo[3].user_id ? this.priceReject() : this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            }
        },
        // 销售代表提交审核
        sellerCheck() {
            console.log('sellerCheck')
            var priceArr = [];
            this.orderInfo.orderitem.forEach(item => {
                let temp = {};
                temp.item_id = item.orderitem_id
                temp.price = item.orderitem_last_price
                priceArr.push(temp);
            })
            var sendObj = {
                oid: this.$route.query.oid,
                last_price: this.totalPrice,
                price_arr: priceArr,
                check_user: this.checkUserInfo
            };
            this.xhrSubmitOrder(sendObj, res => {
                if (res.data.data == '您审核完成') {
                    this.$message({
                        type: 'success',
                        message: '审核成功！'
                    })
                    this.orderInfo.status++;
                    this.checkUserInfo[0].check_status = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: '审核失败！'
                    })
                }
            })
        },
        // 区域经理提交审核
        areaCheck() {
            console.log('areaCheck')
            var sendObj = {
                oid: this.$route.query.oid,
                check_user: this.checkUserInfo
            }
            this.xhrSubmitOrder(sendObj, res => {
                if (res.data.data == '您审核完成') {
                    this.$message({
                        type: 'success',
                        message: '审核成功！'
                    })
                    this.orderInfo.status++;
                    this.checkUserInfo[1].check_status = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: '审核失败！'
                    })
                }
            })
        },
        // 物流岗位提交审核
        logisticsCheck() {
            console.log('logisticsCheck')
            if (this.outGoodsAddress == '') {
                this.$message({
                    type: 'warning',
                    message: '未填写发货地'
                })
                return;
            }
            var sendObj = {
                oid: this.$route.query.oid,
                seller_address: this.outGoodsAddress,
                check_user: this.checkUserInfo
            }
            this.xhrSubmitOrder(sendObj, res => {
                if (res.data.data == '您审核完成') {
                    this.$message({
                        type: 'success',
                        message: '审核成功！'
                    })
                    this.orderInfo.status++;
                    this.checkUserInfo[2].check_status = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: '审核失败！'
                    })
                }
            })
        },
        // 价格岗位提交审核
        priceCheck() {
            console.log('priceCheck')
            var sendObj = {
                oid: this.$route.query.oid,
                check_user: this.checkUserInfo
            }
            this.xhrSubmitOrder(sendObj, res => {
                if (res.data.data == '您审核完成') {
                    this.$message({
                        type: 'success',
                        message: '审核成功！'
                    })
                    this.orderInfo.status++;
                    this.checkUserInfo[3].check_status = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: '审核失败！'
                    })
                }
            })
        },
        // 经销商审核欺负门店
        checkStore() {
            if(this.user.id == this.checkUserInfo[0].user_id) {
                if(this.outGoodsAddress == '') {
                    this.$message({
                        type: 'warning',
                        message: '未填写发货地址！'
                    })
                    return;
                }
                var sendObj = {
                    oid: this.$route.query.oid,
                    seller_address: this.outGoodsAddress,
                    check_user: this.checkUserInfo
                };
                this.xhrSubmitOrder(sendObj, res => {
                    if (res.data.data == '您审核完成') {
                        this.$message({
                            type: 'success',
                            message: '审核成功！'
                        })
                        this.orderInfo.status++;
                        this.checkUserInfo[0].check_status = true;
                    } 
                    else {
                        this.$message({
                            type: 'error',
                            message: '审核失败！'
                        })
                    }
                })
            }
            else {
                this.$message({
                    type: 'warning',
                    message: '您不应该操作这里！'
                })
            }
        },
        // 区域经理驳回审核
        areaReject() {
            console.log('areaReject')
            this.xhrCheckReject(res => {
                if (res.data.msg == '操作完成') {
                    this.orderInfo.status--;
                    this.checkUserInfo[0].check_status = false;
                    this.$message({
                        type: 'success',
                        message: '审核驳回成功！'
                    })
                }
            })
        },
        // 物流岗位驳回审核
        logisticsReject() {
            console.log('areaReject')
            this.xhrCheckReject(res => {
                if (res.data.msg == '操作完成') {
                    this.orderInfo.status--;
                    this.checkUserInfo[1].check_status = false;
                    this.$message({
                        type: 'success',
                        message: '审核驳回成功！'
                    })
                }
            })
        },
        // 价格岗位驳回审核
        priceReject() {
            console.log('priceReject')
            this.xhrCheckReject(res => {
                if (res.data.msg == '操作完成') {
                    this.orderInfo.status--;
                    this.checkUserInfo[2].check_status = false;
                    this.$message({
                        type: 'success',
                        message: '审核驳回成功！'
                    })
                }
            })
        },
        // 填写发货地
        writeAddress(flag) {
            if(this.orderInfo.order_type_num == 1) {
                if (this.user.id == this.checkUserInfo[2].user_id) {
                    this.dialogFormVisible = true;
                } else {
                    this.$message({
                        type: 'warning',
                        message: '您不应该操作这里！'
                    })
                }
            }
            else {
                if (this.user.id == this.checkUserInfo[0].user_id) {
                    this.dialogFormVisible = true;
                } else {
                    this.$message({
                        type: 'warning',
                        message: '您不应该操作这里！'
                    })
                }
            }
        },
        outGoodsOk() {
            this.orderInfo.seller_address = this.outGoodsAddress;
            this.dialogFormVisible = false;
        },
        outGoodsQuit() {
            this.outGoodsAddress = '';
            this.dialogFormVisible = false;
        },
        xhrSubmitOrder(sendObj, callback) {
            this.axios.post('check_order', JSON.stringify(sendObj))
                .then(res => {
                    if ((typeof callback) == 'function') {
                        callback(res);
                    }
                })
        },
        // 审核驳回
        xhrCheckReject(callback) {
            this.axios('revoke_order', {
                    params: {
                        oid: this.$route.query.oid
                    }
                })
                .then(res => {
                    if ((typeof callback) == 'function') {
                        callback(res);
                    }
                })
        },
        // 下载合同
        downloadContract() {
            // window.location.href = 'https://xarh.sprucesmart.com/api/v1/print_contract?oid=' + this.$route.query.oid + '&spl_token=' + Cookie.get('xian-spl-token');
            window.open('https://xarh.sprucesmart.com/api/v1/print_contract?oid=' + this.$route.query.oid + '&spl_token=' + Cookie.get('xian-spl-token') + '&oil_type=3','_blank');
        }
    }
}
</script>

<style scoped>
.hide {
    display: none;
}
.order-detail {
    width: 100%;
    padding-top: 1px;
    background-color: #f1f1f1
}

.order-detail .bg-head-nav {
    background-color: #d2f5e8;
    height: 143px;
}

.content-detail {
    position: relative;
    top: -105px;
    width: 90%;
    margin: 0 auto;
    background-color: transparent;
}

.baseinfo {
    position: relative;
}

.order-detail .baseinfo-title {
    font-size: 22px;
    color: #fff;
    text-align: center;
    line-height: 46px;
    background-color: #00ae66;
    border-radius: 7px 7px 0 0;
}

.order-detail .baseinfo-content {
    background-color: #fff;
}

.order-detail .baseinfo-content-left {
    padding-left: 130px;
    color: #242424;
    font-size: 18px;
}

.order-detail .baseinfo-content-right {
    padding-left: 0;
    color: #242424;
    font-size: 18px;
}

.orderinfo {
    background-color: transparent;
    padding-top: 24px;
}

.content-detail>div:last-child {
    padding-bottom: 15px;
    padding-top: 8px;
}

.order-detail .baseinfo-content-left p {
    line-height: 40px;
}

.order-detail-table {
    border-radius: 7px 7px 0 0;
}

.total-price {
    height: 65px;
    padding-left: 64px;
    line-height: 65px;
    background-color: #f6f6f6;
    font-size: 17px;
    color: #333;
}

.total-price-text {
    margin-right: 10px;
}

.content-detail>div:last-child {
    padding-bottom: 15px;
    padding-top: 8px;
}

.check-process {
    background-color: #fff;
    padding-left: 60px;
}

.check-process {
    position: relative;
}

.check-process>div {
    padding-left: 8px;
    line-height: 40px;
}

.area-manager {
    margin-top: 16px;
}

.check-process>div>p {
    display: inline-block;
    font-size: 18px;
    color: #525252;
    margin: 0;
}

.area-check {
    display: inline-block;
    margin: 0 0 0 16px;
}

.area-check {
    display: inline-block;
    margin: 0 0 0 16px;
}

.area-check>p {
    display: inline-block;
    margin: 0;
}

.check-process>div>p:first-of-type>span:nth-of-type(1) {
    font-size: 20px;
    color: #282828;
}

.check-process>div>p:first-of-type>span:nth-of-type(2) {
    position: relative;
    top: 14px;
    display: inline-block;
    width: 80px;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
}

.area-check>p>span:nth-of-type(2),
.check-process>div>p>span:nth-of-type(2),
.check-process>div>p:nth-of-type(2),
.check-process>div>p:nth-of-type(3) {
    margin-left: 16px;
}

.btn-reject,
.circle {
    display: inline-block;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    color: #fff;
}

.btn-reject {
    background-color: #ae0000;
}

.area-check>p {
    display: inline-block;
    margin: 0;
}

.btn-reject,
.circle {
    display: inline-block;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    color: #fff;
}

.circle {
    background-color: #00ae66;
}

.changeAddress {
    bottom: 6px;
    left: 429px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #67c23a;
    border-color: #67c23a;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
}

.check-process>div {
    padding-left: 8px;
    line-height: 40px;
}

.order-detail-check-bg {
    position: absolute;
    top: 34px;
    left: 35px;
    width: 11px;
    height: 226px;
    background-image: url(../../assets/imgs/order-detail-check-bg.png);
    background-size: 100% 100%;
}

.order-detail-check-bg .order-detail-small-circle {
    position: absolute;
    top: 0;
    left: 1px;
    width: 16px;
    height: 16px;
    border-radius: 20px;
}

.order-detail-circle-empty {
    background-image: url(../../assets/imgs/order-detail-circle-empty.png);
    background-size: 100% 100%;
}

.order-detail-check-bg .small-circle2 {
    top: 69px;
}

.order-detail-circle-full {
    background-image: url(../../assets/imgs/order-detail-circle-full.png);
    background-size: 100% 100%;
}

.order-detail-check-bg .small-circle3 {
    top: 135px;
}

.order-detail-check-bg .small-circle4 {
    top: 209px;
}

.logistics {
    margin-top: 12px;
}

.price-manager {
    margin-top: 19px;
}

.changeAddress {
    bottom: 6px;
    left: 429px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #67c23a;
    border-color: #67c23a;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
}

.bg-green {
    background-color: #ccc !important;
    color: #fff !important;
}

.btn-checkSend,
.btn-downContract {
    position: fixed;
    right: 63px;
    bottom: 180px;
    width: 80px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border-radius: 8px;
    color: #fff;
    background-color: #85ce61;
    cursor: pointer;
    z-index: 234;
}

.btn-checkSend {
    bottom: 124px;
}
</style><style>
.order-detail .orderinfo .el-input__inner {
    color: #ff6e15 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/OrderDetailLook.vue